import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import handleWheel from "utils/handleOnWheel";
import { CreateCommanWay, ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { object } from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import { ArrowDownIcon, ArrowsUpDownIcon, ArrowUpIcon, PlusIcon } from "@heroicons/react/24/outline";
import { AfDataType } from "utils/TableColumnData";
import Modal from "components/Modal/Modal";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";

const WalletList: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const navigator = useNavigate();
  const [tableData, setTableData] = useState<any>([]);
  const [totals, setTotals] = useState<any>({});
  const [agentId, setAgentId] = useState("");
  const [startDate, setStartDate] = useState<any>(moment().startOf("day").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));
  const [sortStat, setSortStat] = useState<any>({});
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [perPage, setPerPageCount] = useState<number>(25);
  const [pageCount, setPageCount] = useState<number>(1);
  const [itemCount, setItemCount] = useState<number>(1);
  
  // Modal state for adding wallet recharge
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newWallet, setNewWallet] = useState({
    customer: null as any,
    date: moment().format("YYYY-MM-DD"),
    remark: "",
    utr: "",
    payMode: "",
    amount: "",
  });

  const [query, setQuery] = useState<any>({
    createdAt: {
      $gte: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      $lte: moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
    },
    /*qry: `date >= '${moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")}' AND date <= '${moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss")}'`,*/
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isDataAdded, setIsDataAdded] = useState(false);

  const [nestedTables, setNestedTables] = useState<any>({});
  const [nestedSelectedOptions, setNestedSelectedOptions] = useState<any>({});

  const [branchOpt, setBranchOtp] = useState<any>();
  const [branchOptions, setBranchOptions] = useState<any>([{ value: 0, label: "Loading..." }]);
  const defaultOptions: any = [{ value: 0, label: "Loading..." }];

  const {
    error: branchError,
    isFetching: branchIsFetching,
    isError: branchIsError,
    isFetched: branchIsFetched,
    isLoading: branchIsLoading,
    refetch: branchRefetch,
  } = useQuery(["BranchesListApi"], () => ListCommanWay("/admin/customer/list", {}, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        data.data.data.forEach((p) => {
          opt.push({
            value: p.id,
            label: p.sh,
          });
        });
        setBranchOptions(opt);
      }
    },
  });

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_wallet_report_list", currentPage],
    () =>
      ListCommanWay(
        "/admin/wallet/list",
        {
          ...query,
        },
        { 
          include: ["_customer", "_subbranch", "_awbNo"],
          page: currentPage,
          paginate: perPage
        }
      ),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data.data);
          setTableData(data.data.data);
          setSortStat({});
          
          // Update pagination info
          if (data.data.paginator) {
            setCurrentPage(data.data.paginator.currentPage);
            setPerPageCount(data.data.paginator.perPage);
            setPageCount(data.data.paginator.pageCount);
            setItemCount(data.data.paginator.itemCount);
          }

          if (branchOpt?.value) {
            /*let ary = [...data.data.data];
            let ttt = {
              grand: 0,
            };
            ary.forEach((a) => {
              ttt.grand += Number(a.amount) || 0;
            });
            setTotals(ttt);*/
            setTotals({ grand: data.data.ballance });
          } else {
            setTotals({ grand: "" });
          }
        } else {
          setTableData([]);
        }
      },
      onError: (data) => {
        setTableData([]);
      },
    }
  );

  useEffect(() => {
    setTotals({ grand: 0 });
    refetch();
  }, [query]);

  // Mutation for creating wallet recharge
  const { mutate: createWallet, isLoading: isCreating } = useMutation(
    (data: any) => CreateCommanWay({ url: "/admin/wallet/create", data }),
    {
      onSuccess: (data: any) => {
        if (data.status === "SUCCESS") {
          UseToast("Wallet recharge added successfully!", "success");
          setIsModalOpen(false);
          setNewWallet({
            customer: null,
            date: moment().format("YYYY-MM-DD"),
            remark: "",
            utr: "",
            payMode: "",
            amount: "",
          });
          refetch();
        } else {
          UseToast(data.message || "Failed to add wallet recharge", "error");
        }
      },
      onError: (error: any) => {
        UseToast("Failed to add wallet recharge", "error");
      },
    }
  );

  const handleAddWallet = () => {
    if (!newWallet.customer?.value) {
      UseToast("Please select a customer", "error");
      return;
    }
    if (!newWallet.amount || isNaN(Number(newWallet.amount))) {
      UseToast("Please enter a valid amount", "error");
      return;
    }
    createWallet({
      customer: newWallet.customer.value,
      date: newWallet.date,
      remark: newWallet.remark,
      utr: newWallet.utr,
      payMode: newWallet.payMode,
      amount: Number(newWallet.amount),
    });
  };

  const __handleSubmit = async () => {
    setIsDataAdded(!isDataAdded);
    setCurrentPage(1); // Reset to first page when filters change

    setQuery({
      createdAt: {
        $gte: startDate ? startDate : moment().startOf("day").subtract(7, "days").format("YYYY-MM-DD HH:mm:ss"),
        $lte: endDate ? moment(endDate).endOf("D").format("YYYY-MM-DD HH:mm:ss") : moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      },
      customer: branchOpt?.value,
    });
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});
  const tableRef = useRef(null);

  const exportToExcel = () => {
    const table = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }
    const toIgnore = tableClone.querySelectorAll(".ignore-excel");
    if (toIgnore.length > 0) {
      toIgnore[0].remove();
    }

    const rows = tableClone.querySelectorAll("tbody tr");
    rows.forEach((row) => {
      const dateCell = row.cells[1]; // Second column is at index 1
      dateCell.innerText = moment(dateCell.innerText, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    console.log(tableClone);

    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Wallet Report.xlsx");
  };

  const GET_SORT_ICON = (key, info) => {
    switch (sortStat[key]) {
      case "asc":
        return (
          <ArrowDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      case "desc":
        return (
          <ArrowUpIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      default:
        return (
          <ArrowsUpDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
    }
  };

  const handleSort = (key, info) => {
    let data = [...tableData];
    let order = sortStat[key] == "asc" ? "desc" : "asc";

    if (key == "_invoice_no_c_b.isFullPaid") {
      data = data.sort((a, b) => {
        if (order == "asc") {
          return -a["isActive"] + b["isActive"];
        } else {
          return -b["isActive"] + a["isActive"];
        }
      });
    }

    let sortedData = data.sort((a, b) => {
      // Extract the value using the keyPath (e.g., "invoice_data.idpaid")
      const valueA = key.split(".").reduce((obj, key) => obj[key], a);
      const valueB = key.split(".").reduce((obj, key) => obj[key], b);
      // Handle sorting for different data types
      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0; // If equal
    });
    let _sortStat = { ...sortStat };
    _sortStat[key] = order;
    setSortStat(_sortStat);
    setTableData(sortedData);
  };

  return (
    <>
      <div className="flex items-center justify-center gap-4 mb-4 mt-3">
        <h1 className="text-lg font-semibold">Wallet Report</h1>
        <button
          onClick={() => setIsModalOpen(true)}
          className="flex items-center gap-1 bg-blue-600 text-white px-3 py-1.5 rounded-md text-sm font-medium hover:bg-blue-700"
        >
          <PlusIcon className="h-4 w-4" />
          New
        </button>
      </div>
      <div className="px-4  border-[1px] p-4 m-4 rounded-md">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-x-4 gap-y-2">
            {(userDetails.role_name == 1 || userDetails.role_name == 8 || userDetails.role_name == 13) && (
              <div className={`items-center gap-2`}>
                <label className="mb-2 text-sm font-semibold text-gray-900">Subbranch</label>
                <Select
                  className={`${false ? "bg-gray-300" : ""} w-48 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                  options={branchOptions}
                  onChange={(e) => {
                    setBranchOtp(e);
                  }}
                  value={branchOpt}
                  isClearable={true}
                />
              </div>
            )}

            <AfDateRangePicker setStartDate={setStartDate} setEndDate={setEndDate} label="Start - End Date" />
            <button
              type="button"
              onClick={__handleSubmit}
              className="ml-2 mt-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
            >
              Submit
            </button>

            <div>
              Ballance:{" "}
              <span style={{ fontWeight: 600, color: "red" }} className="">
                {new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(Number(totals.grand))}
              </span>
            </div>
            <button onClick={exportToExcel} className=" bg-blue-600 text-white px-4 py-1 rounded-md">
              Excel Export
            </button>
          </div>
        </div>
      </div>

      <div className="px-4">
        <table className="w-full table- mb-8" style={{ fontSize: "85%" }} id="myTable" ref={tableRef}>
          <thead className="sticky top-0 bg-gray-300">
            <tr>
              <th className="border border-slate-200 px-1">Sr.</th>
              <th className="border border-slate-200 px-1">Date</th>
              <th className="border border-slate-200 px-1">Customer</th>
              <th className="border border-slate-200 px-1">Book_Ref</th>
              <th className="border border-slate-200 px-1">Weight</th>
              <th className="border border-slate-200 px-1">Destination</th>
              <th className="border border-slate-200 px-1">Subbranch</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Amount {GET_SORT_ICON("amount", "asc")}</th>
              <th className="border border-slate-200 px-1">Pay Mode</th>
              <th className="border border-slate-200 px-1">Transaction Id</th>
              <th className="border border-slate-200 px-1">Remark</th>
            </tr>
          </thead>
          <tbody>
            {tableData &&
              tableData.map((r, i) => {
                return (
                  <tr key={"r" + r.id} className={`${!r.isActive ? "bg-red-200" : r._invoice_no_c_b?.isFullPaid ? "bg-green-300" : ""}`}>
                    <td className="border border-slate-200 px-2">{i + 1}</td>
                    <td className="border border-slate-200 px-2">{moment(r.date).format("DD/MM/YYYY")}</td>
                    <td className="border border-slate-200 px-2">
                      ({r._customer?.code}) {r._customer?.sh}
                    </td>
                    <td className="border border-slate-200 px-2 text-center">{r._awbNo?.awb_no || "-"}</td>
                    <td className="border border-slate-200 px-2 text-center">{r._awbNo?.weight || "-"}</td>
                    <td className="border border-slate-200 px-2 text-center">{r._awbNo?.destination || "-"}</td>
                    <td className="border border-slate-200 px-2 text-center">{r._subbranch?.branch_name}</td>
                    <td className="border border-slate-200 px-2">{Number(r.amount).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2">{r.payMode}</td>
                    <td className="border border-slate-200 px-2">{r.utr}</td>
                    <td className="border border-slate-200 px-2">{r.remark}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <nav className="flex items-center justify-between pt-4 px-4" aria-label="Table navigation">
        <span className="text-sm font-normal text-gray-500">
          Total: <span className="font-semibold text-gray-900">{itemCount}</span>
        </span>
        <ul className="inline-flex -space-x-px text-sm h-8">
          <li>
            <button
              onClick={() => setCurrentPage((prevData) => (prevData > 1 ? prevData - 1 : prevData))}
              disabled={currentPage === 1}
              className="flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Previous
            </button>
          </li>
          {Array.from({ length: pageCount }, (_, i) => i + 1).map((p) => (
            <li key={"paginate-" + p}>
              <button
                onClick={() => setCurrentPage(p)}
                type="button"
                aria-current={currentPage === p ? "page" : undefined}
                className={`flex items-center justify-center px-3 h-8 border border-gray-300
                  ${
                    currentPage === p
                      ? "text-blue-600 bg-blue-50 hover:bg-blue-100 hover:text-blue-700"
                      : "text-gray-500 bg-white hover:bg-gray-100 hover:text-gray-700"
                  }`}
              >
                {p}
              </button>
            </li>
          ))}
          <li>
            <button
              onClick={() => setCurrentPage((prevData) => (prevData < pageCount ? prevData + 1 : prevData))}
              disabled={currentPage === pageCount}
              className="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </li>
        </ul>
      </nav>

      {/* Add Wallet Recharge Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 overflow-y-auto z-50">
          <div className="flex items-center justify-center min-h-screen">
            <div className="fixed inset-0 bg-black opacity-50" onClick={() => setIsModalOpen(false)}></div>
            <div className="z-50 flex flex-col bg-white p-6 rounded-lg shadow-2xl border-2 border-gray-300 min-w-[400px]">
              <h2 className="text-lg font-semibold mb-4">Add Wallet Recharge</h2>
              
              <div className="flex flex-col gap-4">
                <div>
                  <label className="block mb-1 text-sm font-medium text-gray-900">Customer *</label>
                  <Select
                    className="w-full bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg"
                    options={branchOptions}
                    onChange={(e) => setNewWallet({ ...newWallet, customer: e })}
                    value={newWallet.customer}
                    isClearable={true}
                    placeholder="Select Customer"
                  />
                </div>

                <div>
                  <label className="block mb-1 text-sm font-medium text-gray-900">Date</label>
                  <input
                    type="date"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    value={newWallet.date}
                    onChange={(e) => setNewWallet({ ...newWallet, date: e.target.value })}
                  />
                </div>

                <div>
                  <label className="block mb-1 text-sm font-medium text-gray-900">Amount *</label>
                  <input
                    type="number"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    placeholder="Enter amount"
                    value={newWallet.amount}
                    onChange={(e) => setNewWallet({ ...newWallet, amount: e.target.value })}
                  />
                </div>

                <div>
                  <label className="block mb-1 text-sm font-medium text-gray-900">Pay Mode</label>
                  <select
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    value={newWallet.payMode}
                    onChange={(e) => setNewWallet({ ...newWallet, payMode: e.target.value })}
                  >
                    <option value="">Select Pay Mode</option>
                    <option value="Cash">Cash</option>
                    <option value="UPI">UPI</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Cheque">Cheque</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div>
                  <label className="block mb-1 text-sm font-medium text-gray-900">UTR / Transaction ID</label>
                  <input
                    type="text"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    placeholder="Enter UTR or Transaction ID"
                    value={newWallet.utr}
                    onChange={(e) => setNewWallet({ ...newWallet, utr: e.target.value })}
                  />
                </div>

                <div>
                  <label className="block mb-1 text-sm font-medium text-gray-900">Remark</label>
                  <textarea
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    placeholder="Enter remark"
                    rows={2}
                    value={newWallet.remark}
                    onChange={(e) => setNewWallet({ ...newWallet, remark: e.target.value })}
                  />
                </div>
              </div>

              <div className="flex justify-end gap-2 mt-6">
                <button
                  className="rounded-md px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 hover:bg-gray-300"
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 hover:bg-green-600 disabled:opacity-50"
                  onClick={handleAddWallet}
                  disabled={isCreating}
                >
                  {isCreating ? "Adding..." : "Add Recharge"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WalletList;
